import "./styles.less";

import { Button, Card, Col, Row, Space, Typography } from "antd";
import React, { ReactNode } from "react";

import { ButtonProps } from "antd/lib/button/button";
import { ImagenOptimizada } from "../../../shared-components/Components/Image/web";
import { useTheme } from "../../../shared-components/Styles/ThemeHook";

export const PaymentMethods = () => {
	return (
		<picture>
			<source
				srcSet="https://cdn2.infocasas.com.uy/web/6007491463224_infocdn__payment_mobile.png"
				media="(max-width: 980px)"
			/>
			<img
				className="img"
				src="https://cdn2.infocasas.com.uy/web/60074914ad3c2_infocdn__payment.png"
				alt="Pasarela de pagos"
			/>
		</picture>
	);
};

export const CardCEEE = ({
	title = null,
	subtitle = null,
	body = null,
	buttonSettings = false,
}: {
	title?: string | null;
	subtitle?: string | null;
	body?: ReactNode | null;
	buttonSettings?: ButtonProps | false;
}) => {
	const { theme } = useTheme();
	return (
		<Card
			className={"CardCEEE"}
			bordered={false}
			size={"small"}
			cover={
				<Space direction={"vertical"}>
					{subtitle && <Typography.Text>{subtitle}</Typography.Text>}
					{title && <Typography.Title level={4}>{title}</Typography.Title>}
				</Space>
			}>
			<Row gutter={[0, theme.spacing.lgSpacing]} justify={"center"}>
				<Col span={24}>
					<ImagenOptimizada
						src={
							"https://cdn2.infocasas.com.uy/web/5ee378d5b5832_infocdn__footer-dueno-publica@3x.png"
						}
						alt={"CEEE"}
						className={"img"}
					/>
				</Col>
				{body && <Col span={24}>{body}</Col>}
				{buttonSettings && (
					<Col span={24}>
						<Button {...buttonSettings} />
					</Col>
				)}
			</Row>
		</Card>
	);
};
